import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        path: '',
        lazy: async () => {
            const { Layout } = await import('@@routes/geneeaEntities');

            return { Component: Layout };
        },
        children: [
            {
                path: ':id',
                lazy: async () => {
                    const { default: GeneeaEntityForm } =
                        await import('@@routes/geneeaEntities/GeneeaEntityForm');

                    return { Component: GeneeaEntityForm };
                },
            },
        ],
    },
];
